/***
 * Created on 2024/2/20
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React from 'react';
import {useTranslation} from "react-i18next";
import ModalDialog from "../../../../common/modal_dialog/modalDialog";
import QnapAuthAppStepContent from "./qnap_auth_app_step_content";

function BindQnapAuthAppSuccess({state, dispatch, ...props}) {
    const { t } = useTranslation();


    const onSignout = () => {
        location.href = '/signout'
    }
    console.log(state)

    return (
        <ModalDialog {...props} title={t('@Verify through an app@')}
                     withWizardMode={true} withStepBar={true}
                     stepContent={() => QnapAuthAppStepContent({state, step: ['approval'].includes(state?.method) ? 3 : 2})}
                     submitText={t('@Sign in again@')} hideCancel={true} submitAction={onSignout}>
            <div className="dialog-content dialog-content--two-step">
                {state.method !== 'totp' &&
                    <div className="two-step--verify two-step--verify--finished">
                        <div className="dialog__sub-title color-primary">{t('@2 Step Verification Set Up Successfully!@')}</div>

                        {state.method === 'qrcode' && <p>{t('@Sign in by scanning the QR code on the sign-in page with your QNAP Authenticator app.@')}</p>}
                        {state.method === 'approval' && <p>{t("@During sign in, open QNAP Authenticator on your paired device and tap 'Approve' to seamlessly complete the process.@")}</p>}
                        {state.method === 'verification' && <p>{t("@Receive push notifications on your paired device and enter the verification code in the app during login.@")}</p>}

                        <div className="dialog__info-grid mt-14">
                            <div className="info-grid__row">
                                <div className="info-grid__row__label">{t('@Mobile Device@')}</div>
                                <div className="info-grid__row__val">{state?.device?.model_name}</div>
                            </div>
                            <div className="info-grid__row">
                                <div className="info-grid__row__label">{t('@OS Version@')}</div>
                                <div className="info-grid__row__val">{state?.device?.device_os}</div>
                            </div>
                            <div className="info-grid__row">
                                <div className="info-grid__row__label">{t('@App Version@')}</div>
                                <div className="info-grid__row__val">{state?.device?.app_version}</div>
                            </div>
                        </div>
                    </div>
                }

                {state.method === 'totp' &&
                    <div className="two-step--verify two-step--verify--finished align-items-center justify-content-center">
                        <div className="dialog__sub-title color-primary">{t('@Code accepted!@')}</div>
                        <p>{t('@You can use your authenticator app to sign in to your QNAP ID now.@')}</p>
                    </div>
                }
            </div>
        </ModalDialog>
    );
}

export default BindQnapAuthAppSuccess;